import { render, staticRenderFns } from "./CompilationSliderForMobile.vue?vue&type=template&id=b7ea9e24&scoped=true&"
import script from "./CompilationSliderForMobile.vue?vue&type=script&lang=js&"
export * from "./CompilationSliderForMobile.vue?vue&type=script&lang=js&"
import style0 from "./CompilationSliderForMobile.vue?vue&type=style&index=0&id=b7ea9e24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ea9e24",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CompilationItem: require('/home/bitrix/frontend/components/compilations/CompilationItem.vue').default})
